import { axiosInstance } from '@/plugins/axios';

export class filter {
  constructor({ filterTypeId, filterTypeName, operator, value }) {
    this.subscriptionFilterId = -1;
    this.subscriptionFilterTypeOperator = operator;
    this.subscriptionFilterTypeName = filterTypeName;
    this.subscriptionFilterTypeId = filterTypeId;
    this.subscriptionFilterTypeInputValue = value;
    this.subscriptionFilterTypeInputLookup = '';
  }
}

const getInitialState = () => ({
  isIntervalEnabled: false,
  clientQuoteTypeId: null,
  callType: null,
  loading: true,
  dirty: false,
  filters: [],
  filterTypes: [],
  filterTypesOperators: [],
});

export const moduleState = getInitialState();

export const actions = {
  async getFilters({ commit, dispatch }, { clientQuoteTypeId, callType, clearIds = false }) {
    commit('setLoading', true);
    const method = callType === 'ColdTransfer' ? 'TazSubscriptionFilters' : 'SubscriptionFilters';
    const response = await axiosInstance
      .get(`api/LeadType/Get${method}/${clientQuoteTypeId}/`)
      .catch(err => err);

    if (response instanceof Error) {
      dispatch(
        'toastr/error',
        `Failed to get schedule. Please check your connection and try again.`,
        {
          root: true,
        }
      );
      // TODO: This should dispatch an action that will log this error.
      commit('setLoading', false);
      return;
    }

    if (clearIds) {
      response.data.subscriptionFilters.forEach(f => {
        f.subscriptionFilterId = null;
      });
    }

    commit('setFilters', response.data.subscriptionFilters);
    commit('setfilterTypesOperators', response.data.subscriptionFilterTypes);
    commit('setFilterTypes', response.data.subscriptionFilterTypes);
    commit('setCallType', callType);
    commit('setClientQuoteTypeId', clientQuoteTypeId);
    commit('setLoading', false);
  },

  async saveFilters({ commit, dispatch, state }, clientQuoteTypeId) {
    let saveSucess = true;
    if (!state.dirty) return saveSucess;

    commit('setLoading', true);
    const method =
      state.callType === 'ColdTransfer' ? 'TazSubscriptionFilter' : 'SubscriptionFilter';

    const response = await axiosInstance
      .post(`api/LeadType/Upsert${method}/${clientQuoteTypeId}`, state.filters)
      .catch(err => err);

    if (response instanceof Error || response.status !== 200) {
      saveSucess = false;
      dispatch(
        'toastr/error',
        'Failed to save filter. Please check your connection and try again.',
        {
          root: true,
        }
      );
    }

    commit('setLoading', false);
    commit('setDirty', !saveSucess);

    return saveSucess;
  },

  addFilter({ commit }, { index, filterId, filterTypeId, filterTypeName, operator, value }) {
    commit('addFilter', {
      index,
      filterId,
      filterTypeId,
      filterTypeName,
      operator,
      value,
    });
    commit('setDirty', true);
  },

  removeFilter({ commit }, index) {
    if (index < 0) return;
    commit('removeFilter', index);
    commit('setDirty', true);
  },

  resetState({ commit }) {
    commit('resetState');
  },
};

export const mutations = {
  setFilters(state, value) {
    state.filters = value;
  },
  setLoading(state, value) {
    state.loading = value;
  },
  setClientQuoteTypeId(state, value) {
    state.clientQuoteTypeId = value;
  },
  setCallType(state, value) {
    state.callType = value;
  },
  setfilterTypesOperators(state, value) {
    state.filterTypesOperators = value;
  },

  setFilterTypes(state, filterTypes) {
    const seen = new Set();
    state.filterTypes = filterTypes
      .filter(ft => {
        const hasSeen = seen.has(ft.subscriptionFilterTypeName);
        if (!hasSeen) {
          seen.add(ft.subscriptionFilterTypeName);
        }
        return !hasSeen;
      })
      .map(ft => ({
        subscriptionFilterTypeId: ft.subscriptionFilterTypeID,
        subscriptionFilterTypeName: ft.subscriptionFilterTypeName,
      }));
  },
  removeFilter(state, index) {
    state.filters.splice(index, 1);
  },

  addFilter(state, { index, filterId, filterTypeId, filterTypeName, operator, value }) {
    if (index > -1) {
      state.filters[index].subscriptionFilterId = filterId;
      state.filters[index].subscriptionFilterTypeId = filterTypeId;
      state.filters[index].subscriptionFilterTypeOperator = operator;
      state.filters[index].subscriptionFilterTypeName = filterTypeName;
      state.filters[index].subscriptionFilterTypeInputValue = value;
      state.filters[index].subscriptionFilterTypeInputLookup = '';
    } else {
      const filter = {};
      filter.subscriptionFilterId = -1;
      filter.subscriptionFilterTypeId = filterTypeId;
      filter.subscriptionFilterTypeName = filterTypeName;
      filter.subscriptionFilterTypeOperator = operator;
      filter.subscriptionFilterTypeInputValue = value;
      filter.subscriptionFilterTypeInputLookup = '';

      state.filters.push(filter);
    }
  },

  setDirty(state, isDirty) {
    state.dirty = isDirty;
  },

  resetState(state) {
    const initialState = getInitialState();
    Object.keys(state).forEach(key => {
      state[key] = initialState[key];
    });
  },
};
